import { ResumeMainPage } from '../ResumeMainPage'
import { NaturalLanguageSection } from './NaturalLanguageSection.tsx'

export function NaturalLanguagePage() {
    return (
        <ResumeMainPage index="Natural_Language">
            <NaturalLanguageSection />
        </ResumeMainPage>
    )
}
